export default "__VITE_ASSET__WpTs4ntM__"